import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";

import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";

export function ToastComponent(props) {
  const [params, setParams] = useState({});

  const handleClose = () => {
    props.closeToast();
  };

  useEffect(() => {
    if (props.params) {
      setParams(JSON.parse(props.params));
    }

    const timer = setTimeout(() => {
      handleClose();
    }, 10000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [props]);

  if (!params.show) {
    return null;
  }

  // Renderizado via portal direto no <body>: garante que o toast fique
  // fixo na viewport (top-right) independente de qualquer ancestral com
  // transform/overflow que quebre o position:fixed, e independente do
  // scroll do formulário/tela que o chamou.
  return createPortal(
    <ToastContainer
      className="bs-toast toast toast-placement-ex m-2 fade top-0 end-0 show"
      style={{ position: "fixed", right: 0, top: 0, zIndex: 9999 }}
    >
      <Toast onClose={handleClose} bg={params.color?.toLowerCase()}>
        <Toast.Header>
          <strong className="me-auto">{params.title}</strong>
        </Toast.Header>
        <Toast.Body dangerouslySetInnerHTML={{ __html: params.body }} />
      </Toast>
    </ToastContainer>,
    document.body
  );
}
